<div [style]="style" style="stroke: black">
  <mat-spinner [diameter]="size"></mat-spinner>
</div>
